export const messages = {
  title: {
    id: 'admin/promotions.form.conditions.title',
  },
  bin: {
    title: {
      id: 'admin/promotions.form.conditions.bin.title',
    },
  },
  cluster: {
    title: {
      id: 'admin/promotions.form.conditions.cluster',
    },
  },
  orderValue: {
    title: {
      id: 'admin/promotions.form.conditions.order-value',
    },
    min: {
      id: 'admin/promotions.form.review.conditions.order-value.min-only',
    },
    max: {
      id: 'admin/promotions.form.review.conditions.order-value.max-only',
    },
    range: {
      id: 'admin/promotions.form.review.conditions.order-value.full-range',
    },
  },
  itemPriceRange: {
    title: {
      id: 'admin/promotions.form.conditions.item-price-range',
    },
    min: {
      id: 'admin/promotions.form.review.conditions.item-price-range.min-only',
    },
    max: {
      id: 'admin/promotions.form.review.conditions.item-price-range.max-only',
    },
    range: {
      id: 'admin/promotions.form.review.conditions.item-price-range.full-range',
    },
  },
  paymentMethods: {
    title: {
      id: 'admin/promotions.form.conditions.payment-methods.title',
    },
  },
  shippingLocation: {
    title: {
      id: 'admin/promotions.form.conditions.shipping-location',
    },
    tooltip: {
      countries: {
        id: 'admin/promotions.form.review.conditions.shipping-location.countries',
      },
      zipCode: {
        id: 'admin/promotions.form.review.conditions.shipping-location.zip-code',
      },
      range: { id: 'admin/promotions.form.review.conditions.zip-code.range' },
    },
  },
  shippingMethods: {
    title: {
      id: 'admin/promotions.form.conditions.shipping-methods.title',
    },
  },
  utm: {
    title: {
      id: 'admin/promotions.form.conditions.utm',
    },
    tooltip: {
      utmSource: {
        id: 'admin/promotions.form.review.conditions.utm.tooltip.source',
      },
      utmCampaign: {
        id: 'admin/promotions.form.review.conditions.utm.tooltip.campaign',
      },
    },
  },
  utmiCampaign: {
    title: {
      id: 'admin/promotions.form.conditions.utmi.campaign',
    },
  },
  empty: {
    id: 'admin/promotions.form.review.conditions.empty',
  },
  listPrice: {
    tag: {
      defined: {
        id: 'admin/promotions.form.review.conditions.list-price.defined',
      },
      notDefined: {
        id: 'admin/promotions.form.review.conditions.list-price.not-defined',
      },
    },
    tooltip: {
      defined: {
        id: 'admin/promotions.form.conditions.list-price.editor.defined.description',
      },
      notDefined: {
        id: 'admin/promotions.form.conditions.list-price.editor.not-defined.description',
      },
    },
  },
  installments: {
    title: {
      id: 'admin/promotions.form.conditions.installments.title',
    },
    min: {
      id: 'admin/promotions.form.review.conditions.installments.min-only',
    },
    max: {
      id: 'admin/promotions.form.review.conditions.installments.max-only',
    },
    range: {
      id: 'admin/promotions.form.review.conditions.installments.full-range',
    },
  },
  affiliates: {
    title: {
      id: 'admin/promotions.form.conditions.affiliates.title',
    },
    isDifferent: {
      id: 'admin/promotions.form.review.conditions.affiliates.is-different',
    },
  },
  historicalPurchaseValue: {
    title: {
      id: 'admin/promotions.form.conditions.historical-purchase-value',
    },
    tooltip: {
      id: 'admin/promotions.form.conditions.historical-purchase-value.tooltip',
    },
  },
  marketingTags: {
    title: {
      id: 'admin/promotions.form.conditions.marketing-tags.title',
    },
    isDifferent: {
      id: 'admin/promotions.form.conditions.marketing-tags.is-different',
    },
  },
  firstPurchase: {
    tag: {
      id: 'admin/promotions.form.conditions.first-purchase.title',
    },
    tooltip: {
      optional: {
        id: 'admin/promotions.form.conditions.first-purchase.login.optional',
      },
      required: {
        id: 'admin/promotions.form.conditions.first-purchase.login.required',
      },
    },
  },
  subscription: {
    tag: {
      id: 'admin/promotions.form.conditions.subscription.title',
    },
  },
}
